<script setup lang="ts">
type Props = {
  title: string
}

defineProps<Props>()

const { isDesktop } = useResponsive()

const isVisible = ref(false)

const onClick = () => {
  if (isDesktop.value) return

  isVisible.value = !isVisible.value
}
</script>

<template>
  <div class="footer-links-item">
    <span class="footer-links-item__title" @click="onClick">
      {{ title }}

      <the-icon
        v-if="!isDesktop"
        :class="[
          'footer-links-item__icon',
          { 'footer-links-item__icon--reverse': isVisible },
        ]"
        name="expand-down"
        size="20"
        color="var(--ui-text-primary)"
      />
    </span>

    <the-transition-height>
      <div v-if="isVisible || isDesktop" class="footer-links-item__content">
        <slot />
      </div>
    </the-transition-height>
  </div>
</template>

<style scoped lang="scss">
.footer-links-item {
  &__title {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: var(--ui-text-primary);
  }

  &__icon {
    transition: transform 0.3s ease;

    &--reverse {
      transform: rotate(180deg);
    }
  }
}
</style>
